import { normalizeClientAlias } from '../clientAlias';
import { mapChanakyaPosition } from './chanakya';
import { mapCobraPosition } from './cobra';
import { mapVyasaPosition } from './vyasa';
import { mapViduraPosition } from './vidura';

const COBRA_IDS = new Set(['q_cobra', 'q_cobra_v2', 'q_cobra_v3', 'q_cobra_v4']);
const CHANAKYA_IDS = new Set(['chanakya', 'chanakya_inverse']);
const VYASA_IDS = new Set(['vyasa', 'vyasa_v1']);
const VIDURA_IDS = new Set(['vidura', 'vidura_v1']);

export function resolveStrategyFamily(strategyId = '') {
    if (CHANAKYA_IDS.has(strategyId)) {
        return 'chanakya';
    }
    if (VYASA_IDS.has(strategyId)) {
        return 'vyasa';
    }
    if (VIDURA_IDS.has(strategyId)) {
        return 'vidura';
    }
    if (COBRA_IDS.has(strategyId)) {
        return 'cobra';
    }
    return 'cobra';
}

export function normalizePosition(position, labels = {}) {
    switch (resolveStrategyFamily(position?.strategyId)) {
        case 'chanakya':
            return mapChanakyaPosition(position, labels);
        case 'vyasa':
            return mapVyasaPosition(position, labels);
        case 'vidura':
            return mapViduraPosition(position, labels);
        case 'cobra':
        default:
            return mapCobraPosition(position, labels);
    }
}

export function normalizePositions(positions = [], labelMap = new Map()) {
    return positions.map((position) => {
        const labels = labelMap.get(`${position.strategyId}:${position.clientId}`) || {};
        return normalizePosition(position, {
            ...labels,
            clientAlias: normalizeClientAlias(labels.clientAlias || position.clientAlias, position.clientId),
        });
    });
}

export function sortPositions(positions = []) {
    return [...positions].sort((a, b) => {
        if (a.status !== b.status) {
            return a.status === 'open' ? -1 : 1;
        }
        const aTime = a.entryAt ? new Date(a.entryAt).getTime() : 0;
        const bTime = b.entryAt ? new Date(b.entryAt).getTime() : 0;
        return bTime - aTime;
    });
}

export function filterPositionsByInstance(positions = [], selectedInstanceId) {
    if (!selectedInstanceId) {
        return positions;
    }
    const [strategyId, clientId] = selectedInstanceId.split(':');
    if (!strategyId || !clientId) {
        return positions;
    }
    return positions.filter(
        (position) => position.strategyId === strategyId && position.clientId === clientId,
    );
}
